<template>
	<!-- Balance and main content -->
	<div class="w-full md:w-3/4 lg:w-4/5 h-full flex flex-col items-start pair-bg overflow-y-auto custom-scrollbar md:rounded-tr-2xl md:rounded-bl-none md:rounded-tl-none rounded-b-2xl z-10">
		<div class="flex items-center justify-between w-full px-4 md:pt-12 md:px-8">
			<div class="flex items-center justify-center ml-4 md:ml-0">
				<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkMainSend : lightMainSend" alt="Wallet Icon" class="w-6 h-6 md:w-8 md:h-8 mr-3"/>
				<h1 class="text-2xl md:text-4xl font-archivomedium text-[var(--text-color)]">
					{{ isApprove ? 'Approve' : isSign ? 'Sign' : isSwap ? 'Swap' : 'Send' }}
				</h1>
				<img :src="selectedChain.icon" alt="Chain Icon" class="w-8 h-8 md:w-10 md:h-10 mb-4 ml-2 mt-4 cursor-pointer md:top-16 md:right-16"/>
				<button @click="$emit('backToOverview')" class="hidden md:block absolute top-8 right-8">
					<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkX : lightX" alt="Close Icon" class="w-3 h-3"/>
				</button>
			</div>
			<!-- back button -->
			<button @click="$emit('backToSend')" class="block md:hidden ml-auto md:mt-2 mr-4 flex items-center space-x-1 px-3 py-2 text-sm font-archivoregular text-[var(--secondary-text-color)] bg-[var(--accent-color-50)] hover:bg-[var(--accent-color-30)] rounded-full transition-colors">
				<svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
				</svg>
				<span class="hover:text-[var(--secondary-text-color)] text-xs">Back</span>
			</button>
		</div>

		<!-- MAIN CONTENT -->
		<div class="mb-4 mx-auto w-full md:w-[80%] lg:w-[65%] xl:w-[50%] p-4">
			<!-- BTC ONLY  -->
			<div v-if="selectedChain.name === 'Bitcoin'">
				<h2 class="text-2xl font-archivomedium mb-4 text-center text-[var(--text-color)]">
					Send: ({{ qrIndex + 1 }}/{{ chunksLength }})
				</h2>
				<p class="mb-2 md:mb-4 text-center font-archivolight text-sm md:text-md text-[var(--secondary-text-color)]">
					Scan the QR Codes with your Cardware Hardware.
				</p>
				<div class="mb-4 md:mb-6 flex justify-center">
					<QRCodeVue :value="qrCodeUrl" :size="300" level="L" class="bg-[#FFFFFF] p-4 transform rotate-90 rounded-sm" :background="'#FFFFFF'"/>
				</div>
				<div v-if="!isWalletConnect && chunksLength > 1" class="flex space-x-4 mb-6">
					<button @click="$emit('prev-qr')" class="mt-4 w-1/2 font-archivoregular bg-transparent text-[var(--accent-color)] border border-[var(--accent-color)] py-2 px-4 rounded-full hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] transition duration-100 shadow-inner">
						Prev
					</button>
					<button @click="$emit('next-qr')" class="mt-4 w-1/2 font-archivoregular bg-transparent text-[var(--accent-color)] border border-[var(--accent-color)] py-2 px-4 rounded-full hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] transition duration-100 shadow-inner">
						Next
					</button>
				</div>

				<!-- TRANSACTION DETAILS: -->
				<div class="bg-white bg-opacity-10 mt-4 backdrop-blur-md rounded-xl border border-[var(--border-color)] p-4 shadow-lg hover:shadow-lg">
					<p class="md:text-md text-sm font-archivomedium text-[var(--secondary-text-color)]">
						Transaction Details:
					</p>
					<div class="mt-4 space-y-2">
						<div class="flex justify-between">
							<span class="text-xs text-[var(--secondary-text-color)]">Network:</span>
							<span class="text-sm text-[var(--accent-color)] text-right break-all">
								{{ selectedChain.name }}
							</span>
						</div>
						<div class="flex justify-between">
							<span class="text-xs text-[var(--secondary-text-color)]">Address:</span>
							<span class="text-sm text-[var(--accent-color)] text-right break-all pl-8">
								{{ transactionDetails.to }}
							</span>
						</div>
						<div class="flex justify-between">
							<span class="text-xs text-[var(--secondary-text-color)]">Amount:</span>
							<span class="text-sm text-[var(--accent-color)]">
								{{ transactionDetails.amount }} {{ selectedAsset }}
								<small class="mr-2 text-xs font-archivolight text-[var(--price-text-color)]">
									(~{{ transactionDetails.amountUSD }})
								</small>
							</span>
						</div>
						<div class="flex justify-between">
							<span class="text-xs text-[var(--secondary-text-color)]">Fee:</span>
							<span class="text-sm text-[var(--accent-color)]">
								{{ transactionDetails.fee }}
							<small class="mr-2 text-xs font-archivolight text-[var(--price-text-color)]">
								(~{{ transactionDetails.feeUSD }})
							</small>
							</span>
						</div>
					</div>
				</div>
				<button @click="$emit('next-broadcast')" class="my-6 md:mb-8 w-full font-archivoregular hover:bg-transparent hover:text-[var(--accent-color)] border border-[var(--accent-color)] py-2 rounded-full bg-[var(--accent-color)] text-[var(--hover-text-color)] transition duration-100 shadow-inner">
					Broadcast
				</button>
			</div>

			<!-- EVM -->
			<div v-else class="mb-12 md:mb-2">
				<h2 v-if="!isApprove && !isSign && !isSwap" class="text-2xl font-archivomedium mb-4 text-center text-[var(--text-color)]">
					Send: ({{ qrIndex + 1 }}/{{ chunksLength }})
				</h2>
				<h2 v-if="isApprove" class="text-2xl font-archivomedium mb-4 text-center text-[var(--text-color)]">
					Approve: ({{ qrIndex + 1 }}/{{ chunksLength }})
				</h2>
				<h2 v-if="isSign" class="text-2xl font-archivomedium mb-4 text-center text-[var(--text-color)]">
					Sign: ({{ qrIndex + 1 }}/{{ chunksLength }})
				</h2>
				<h2 v-if="isSwap" class="text-2xl font-archivomedium mb-4 text-center text-[var(--text-color)]">
					Swap: ({{ qrIndex + 1 }}/{{ chunksLength }})
				</h2>
				<div v-if="isWalletConnect" class="flex flex-row items-center justify-center space-x-2 mb-4">
					<span class="pulse-dot mb-1"></span>
					<span class="text-sm font-archivolight text-[var(--accent-color)]">Connected</span>
				</div>

				<p class="mb-2 md:mb-4 text-center font-archivolight text-sm md:text-md text-[var(--secondary-text-color)]">
					Scan the QR Code with your Cardware Hardware.
				</p>
				<div class="flex flex-col items-center">
					<div class="mb-4 flex justify-center">
						<QRCodeVue :value="qrCodeUrl" :size="300" level="L" class="bg-[#FFFFFF] p-4" :background="'#FFFFFF'"/>
					</div>

					<div v-if="isApprove" class="info-block flex items-center space-x-2 px-4 py-2 md:py-1 rounded-lg bg-blue-100 border border-blue-300 my-4">
						<svg class="md:w-16 md:h-16 w-20 h-20 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 20a8 8 0 100-16 8 8 0 000 16z" />
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01" />
						</svg>
						<p class="text-sm text-blue-800 text-center py-2">
							You will first need to <strong class="font-archivomedium">approve</strong> this asset for spend, and then you can sign the transaction. This only occurs once per non-native asset, unless revoked. Some dApps require you to approve, sign message and sign transaction on your first time.
						</p>
					</div>

					<!-- TRANSACTION DETAILS -->
					<div v-if="!isApprove" class="bg-white bg-opacity-10 mt-4 backdrop-blur-md rounded-xl border border-[var(--border-color)] p-4 shadow-lg hover:shadow-lg w-full">
						<p class="md:text-md text-sm font-archivomedium text-[var(--secondary-text-color)] mb-2">
							Transaction Details:
						</p>
						<div class="space-y-2">
							<div class="flex justify-between">
								<span class="text-xs text-[var(--secondary-text-color)]">Network:</span>
								<span class="text-sm text-[var(--accent-color)] text-right break-all">
									{{ selectedChain.name }}
								</span>
							</div>
							<div class="flex justify-between">
								<span class="text-xs text-[var(--secondary-text-color)]">Address:</span>
								<span class="text-sm text-[var(--accent-color)] text-right break-all pl-8">
									{{ transactionDetails.to }}
								</span>
							</div>
							<div class="flex justify-between">
								<span class="text-xs text-[var(--secondary-text-color)]">Amount:</span>
								<span class="text-sm text-[var(--accent-color)]">
									{{ transactionDetails.amount }} {{ selectedAsset }}
									<small class="mr-2 text-xs font-archivolight text-[var(--price-text-color)]">
										(~{{ transactionDetails.amountUSD }})
									</small>
								</span>
							</div>
							<div class="flex justify-between">
								<span class="text-xs text-[var(--secondary-text-color)]">Fee:</span>
								<span class="text-sm text-[var(--accent-color)]">
									{{ transactionDetails.fee }}
								<small class="mr-2 text-xs font-archivolight text-[var(--price-text-color)]">
									(~{{ transactionDetails.feeUSD }})
								</small>
								</span>
							</div>
						</div>
					</div>

					<!-- TX HASH -->
					<div @click="$emit('copy-unsigned-hash')" class="bg-white bg-opacity-10 backdrop-blur-md rounded-xl border border-[var(--border-color)] p-4 shadow-lg hover:shadow-lg w-full mt-4">
						<p class="md:text-md text-sm font-archivomedium text-[var(--secondary-text-color)] mb-2">
							Hash (VERIFY ON DEVICE):
						</p>
						<div class="flex items-center justify-between break-all space-x-2">
							<p class="text-sm text-[var(--accent-color)]">
								{{ transactionDetails.txHash }}
							</p>
						</div>
					</div>

					<!-- TX HEX -->
					<div class="bg-white bg-opacity-10 backdrop-blur-md rounded-xl border border-[var(--border-color)] p-4 shadow-lg hover:shadow-lg w-full mt-4 relative">
						<div @click="$emit('toggle-full-unsigned')" class="flex items-center justify-between cursor-pointer">
							<p class="md:text-md text-sm font-archivomedium text-[var(--secondary-text-color)]">
								Verify Yourself:
							</p>
							<button class="cursor-pointer">
								<svg class="w-5 h-5 transition-transform duration-100 text-[var(--secondary-text-color)]" :class="{ 'transform rotate-180': showFullUnsignedTx }" fill="currentColor" viewBox="0 0 20 20">
									<path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"
									/>
								</svg>
							</button>
						</div>
						<div v-if="showFullUnsignedTx" class="mt-4">
							<p class="text-xs my-3 italic text-[var(--secondary-text-color)]">
								Verify the Hash yourself by copying this Raw Transaction Hex and decoding it.
							</p>
							<div class="flex items-center justify-between pr-4 break-all space-x-2">
								<p class="text-sm text-[var(--accent-color)]">
									{{ transactionDetails.unsignedTx }}
								</p>
								<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkCopy : lightCopy" alt="Copy Icon" class="w-5 h-5 cursor-pointer" @click="$emit('copy-unsigned-hex')"/>
							</div>
							<button @click="$emit('open-raw-decoder')" class="mt-6 mb-2 w-full flex items-center justify-center font-archivoregular bg-transparent text-[var(--accent-color)] border border-[var(--accent-color)] py-2 px-4 rounded-full hover:bg-[var(--hover-text-color)] hover:text-[var(--accent-color)] transition duration-200 shadow-inner">
								Don’t Trust, Verify
							</button>
						</div>
					</div>
				</div>

				<div v-if="!isWalletConnect && chunksLength > 1" class="flex space-x-4 mt-4">
					<button @click="$emit('prev-qr')" class="mt-4 w-1/2 font-archivoregular bg-transparent text-[var(--accent-color)] border border-[var(--accent-color)] py-2 px-4 rounded-full hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] transition duration-100 shadow-inner">
						Prev
					</button>
					<button @click="$emit('next-qr')" class="mt-4 w-1/2	font-archivoregular bg-transparent text-[var(--accent-color)] border border-[var(--accent-color)] py-2 px-4 rounded-full hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] transition duration-100 shadow-inner" >
						Next
					</button>
				</div>
				<button @click="$emit('next-broadcast')" class="mt-4 md:mb-8 mb-4 w-full font-archivoregular hover:bg-transparent hover:text-[var(--accent-color)] border border-[var(--accent-color)] py-2 rounded-full bg-[var(--accent-color)] text-[var(--hover-text-color)] transition duration-100 shadow-inner">
					{{ isApprove ? 'Approve & Broadcast' : isSign ? 'Sign & Broadcast' : 'Broadcast' }}
				</button>
			</div>
		</div>
	</div>
</template>

<script setup>
import QRCodeVue from 'qrcode.vue';
import lightMainSend from '../assets/SendIconLightTheme.png';
import darkMainSend from '../assets/SendIconDarkTheme.png';
import lightX from '../assets/X.png';
import darkX from '../assets/XWhite.png';
import lightCopy from '../assets/LightCopyIcon.png';
import darkCopy from '../assets/DarkCopyIcon.png';

const props = defineProps({
	currentTheme: { type: String, required: true },
	selectedChain: { type: Object, required: true },
	selectedAsset: { type: String, required: true },
	qrIndex: { type: Number, required: true },
	chunksLength: { type: Number, required: true },
	qrCodeUrl: { type: String, required: true },
	transactionDetails: { type: Object, required: true },
	showFullUnsignedTx: { type: Boolean, required: true },
	txTypeStr: { type: String, default: '' },
	isApprove: { type: Boolean, default: false },
	isSign: { type: Boolean, default: false },
	isSwap: { type: Boolean, default: false }
});

const isWalletConnect = Boolean(props.txTypeStr);

const emit = defineEmits([
	'prev-qr',
	'next-qr',
	'next-broadcast',
	'backToOverview',
	'backToSend',
	'copy-unsigned-hash',
	'toggle-full-unsigned',
	'copy-unsigned-hex',
	'open-raw-decoder'
]);
</script>

<style scoped>
.pulse-dot {
	display: inline-block;
	width: 12px;
	height: 12px;
	background-color: #38a169;
	border-radius: 50%;
	animation: pulse 1.5s ease-out infinite;
}
@keyframes pulse {
	0% {
		transform: scale(0.8);
		opacity: 0.6;
	}
	50% {
		transform: scale(1.2);
		opacity: 1;
	}
	100% {
		transform: scale(0.8);
		opacity: 0.6;
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.2s ease-in-out;
}
.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>
